import Img_hypervsn from "../img/Img_hypervsn"
import TopGlow from "./topGlow"
import FallingFlakes from "./fallingFlakes"

const isChristmas = true
const Layout = ({ children }) => (
  <div
    css={{
      fontFamily: "Montserrat, sans-serif",
      fontWeight: 400,
      color: "white",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      maxWidth: 480,
      width: "100%",
      height: "calc(100svh - 3px)",
      // minHeight: "100vh" /* fallback */,
      alignItems: "center",
      margin: "0 auto",
      boxSizing: "border-box",
    }}
  >
    {isChristmas && <FallingFlakes />}
    <TopGlow />

    <div css={{ padding: "16px 0" }}>
      <Img_hypervsn />
    </div>
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: 24,
        flex: 1,
        padding: "0 24px 24px 24px",
      }}
    >
      {children}
    </div>
  </div>
)

export default Layout
